import { useState, useMemo } from "react"
import firebase from "firebase"
import moment from "moment"

// UI components
import Tile from "../../components/structure/tile/tile"
import Title from "../../components/structure/title/title"
import DateSelector from "./date-selector"

// Charts
import EnquiriesLineChart from "./charts/enquiries"
import BookingsLineChart from "./charts/bookings"
import MarginsLineChart from "./charts/margins"
import GolfersLineChart from "./charts/golfers"
import SalesLineChart from "./charts/sales"

import "./charting.scss"

// Returns YoY charting information, per month or year
export default function Charting() {
	const [dateSelection, setDateSelection] = useState({
		viewMode: "month",
		year: new Date().getFullYear(),
		month: new Date().getMonth(),
	})
	const [yearsToCompare, setYearsToCompare] = useState(1)

	// Calculate date ranges based on selection
	const dateRanges = useMemo(() => {
		const ranges = []
		const { year, month } = dateSelection

		// Generate ranges for current period and historical periods
		for (let i = 0; i <= yearsToCompare; i++) {
			const targetYear = year - i
			const start = moment().year(targetYear).month(month).startOf("month")
			const end = moment().year(targetYear).month(month).endOf("month")

			ranges.push({
				yearOffset: i,
				year: targetYear,
				start: firebase.firestore.Timestamp.fromMillis(start.valueOf()),
				end: firebase.firestore.Timestamp.fromMillis(end.valueOf()),
			})
		}

		return ranges
	}, [dateSelection, yearsToCompare])

	return (
		<Tile>
			<Title>
				<h1>Statistic Charting</h1>
			</Title>

			<DateSelector
				onDateChange={setDateSelection}
				onYearsToCompareChange={setYearsToCompare}
			/>

			<div className="charting-container">
				<div className="chart-wrapper">
					<MarginsLineChart
						dateRanges={dateRanges}
						selectedYear={dateSelection.year}
						selectedMonth={dateSelection.month}
					/>
				</div>

				<div className="chart-wrapper">
					<SalesLineChart
						dateRanges={dateRanges}
						selectedYear={dateSelection.year}
						selectedMonth={dateSelection.month}
					/>
				</div>

				<div className="chart-wrapper">
					<EnquiriesLineChart
						dateRanges={dateRanges}
						selectedYear={dateSelection.year}
						selectedMonth={dateSelection.month}
					/>
				</div>

				<div className="chart-wrapper">
					<BookingsLineChart
						dateRanges={dateRanges}
						selectedYear={dateSelection.year}
						selectedMonth={dateSelection.month}
					/>
				</div>

				<div className="chart-wrapper">
					<GolfersLineChart
						dateRanges={dateRanges}
						selectedYear={dateSelection.year}
						selectedMonth={dateSelection.month}
					/>
				</div>
			</div>
		</Tile>
	)
}
